import React from 'react';
import { connect } from 'react-redux';
import StoreInfoBlock from './StoreInfoBlock';
import ProductCarousel from './ProductCarousel';
import OfferErrorBlock from './OfferErrorBlock';

import {
  getOfferErrorCode,
  getIsUserOwner,
  getProductsInStore,
  getIsStoreEnabled,
} from '../../reducers/ProductReducers';

const Sidebar = ({
  errorCode,
  isUserOwner,
  productsInStore,
  isStoreEnabled,
}) => {
  return (
    <div>
      { isUserOwner && errorCode ?
        <OfferErrorBlock /> :
        null
      }
      { isStoreEnabled ?
        <div>
          <StoreInfoBlock />
          { productsInStore > 2 ?
            <ProductCarousel /> :
            null
          }
        </div> :
        null
      }
    </div>
  );
};

const mapStateToProps = ({ product }) => ({
  errorCode: getOfferErrorCode(product),
  isUserOwner: getIsUserOwner(product),
  productsInStore: getProductsInStore(product),
  isStoreEnabled: getIsStoreEnabled(product),
});

export default connect(mapStateToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/product/views/_layout/Sidebar.js